import { render, staticRenderFns } from "./Authenticator.vue?vue&type=template&id=1c0b852a"
import script from "./Authenticator.vue?vue&type=script&lang=js"
export * from "./Authenticator.vue?vue&type=script&lang=js"
import style0 from "./Authenticator.vue?vue&type=style&index=0&id=1c0b852a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports